import { z } from "zod";

export const HbIdSchema = z.object({
	hb_id: z.string()
});

export type HbId = z.infer<typeof HbIdSchema>;
